/* eslint-disable */
export const en = {
    'age-restriction': 'Age restriction should be selected',
    'apk-state': 'Select at least one target platform',
    'already-exist': 'An application with the same name already exists',
    'common-names': 'Too common phrases',
    'empty-description': 'Write a description of the application',
    'empty-short-description': 'Write a short description of the application',
    'forbidden-words': 'Contains forbidden words',
    'forbidden-developer-name': "Inflected words were used in the developer's name",
    'name-is-required': 'Name is a required field',
    'name-quouted': "The application's name is quoted",
    'package-name-missing': 'The package name is missing',
    'too-common-phrases': 'The name or activation phrases are too common',
    'too-long': 'It cannot contain more than {characters} characters',
    'validation-developer-name': 'Developer name cannot contain {word}',
    'validation-email': 'Incorrect email address was entered',
    'validation-url': 'Invalid URL entered',
    'wrong-package-name': 'Incorrect package name format',
    'unknown-error': 'Unknown error',
} as const;
export const ru = {
    'age-restriction': 'Необходимо указать возрастное ограничение',
    'apk-state': 'Выберите хотя бы одну платформу распространения',
    'already-exist': 'Приложение с таким именем уже существует',
    'common-names': 'Слишком общие фразы',
    'empty-description': 'Напишите описание приложения',
    'empty-short-description': 'Напишите короткое описание приложения',
    'forbidden-words': 'Содержит запрещенные слова',
    'forbidden-developer-name': 'В имени разработчика использованы склоняемые слова',
    'name-is-required': 'Необходимо указать название',
    'name-quouted': 'Название приложения в кавычках',
    'package-name-missing': 'Отсутствует имя пакета',
    'too-common-phrases': 'Название или фразы активации слишком общие',
    'too-long': 'Не может содержать более {characters} символов',
    'validation-developer-name': 'Имя разработчика не может содержать {word}',
    'validation-email': 'Введен некорректный email',
    'validation-url': 'Введен неверный URL',
    'wrong-package-name': 'Некорректный формат имени пакета',
    'unknown-error': 'Неизвестная ошибка',
} as const;
